import type { MultiSelectOption } from '@avila-roffe/components-web';
import { DESIGN_SYSTEM_THEMES } from './appearance-data';
import { ALL_CURRENCIES, ALL_LOCALES } from './locale-data';

export function toFlag(countryCode: string): string {
  return [...countryCode.toUpperCase()]
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join('');
}

export function resolveTimezoneName(tz: string): string {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      timeZoneName: 'longGeneric',
    }).formatToParts(new Date());
    return parts.find((p) => p.type === 'timeZoneName')?.value ?? tz;
  } catch {
    return tz;
  }
}

export const LOCALE_OPTIONS: MultiSelectOption[] = ALL_LOCALES.map((l) => ({
  value: l.value,
  label: l.label,
  flag: toFlag(l.countryCode),
}));

export const CURRENCY_OPTIONS: MultiSelectOption[] = ALL_CURRENCIES.map((c) => ({
  value: c.value,
  label: `${c.value} — ${c.label}`,
  flag: toFlag(c.countryCode),
}));

export const LOCALE_MAP = new Map(LOCALE_OPTIONS.map((o) => [o.value, o]));
export const CURRENCY_MAP = new Map(CURRENCY_OPTIONS.map((o) => [o.value, o]));

export const THEME_OPTIONS: MultiSelectOption[] = DESIGN_SYSTEM_THEMES.map((t) => ({
  value: t.value,
  label: t.label,
  flag: '',
}));
